var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.667 21.333H95.9971C72.5311 21.333 53.3311 40.533 53.3311 64V341.33C53.3311 353.064 62.9311 362.664 74.6641 362.664C86.3971 362.664 95.9971 353.064 95.9971 341.33V85.33C95.9971 73.597 105.597 63.997 117.331 63.997H330.661C342.394 63.997 351.994 54.397 351.994 42.664C351.994 30.93 342.394 21.33 330.661 21.33L330.667 21.333ZM416 106.667H181.33C157.863 106.667 138.663 125.867 138.663 149.333V448.003C138.663 471.47 157.863 490.67 181.33 490.67H416C439.467 490.67 458.667 471.47 458.667 448.003V149.333C458.667 125.867 439.467 106.667 416 106.667ZM394.667 447.997H202.667C190.934 447.997 181.334 438.397 181.334 426.664V170.664C181.334 158.93 190.934 149.33 202.667 149.33H394.667C406.4 149.33 416 158.93 416 170.664V426.664C416 438.397 406.4 447.997 394.667 447.997Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyDark);
export default __webpack_public_path__ + "static/media/ic-copy-dark.505f7f34b9d89dd607f6c4418dbaecc4.svg";
export { ForwardRef as ReactComponent };